import {AfterViewInit, Component, Input, OnInit} from "@angular/core";
import {FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {CommonModule} from '@angular/common';
import {MatInputModule} from "@angular/material/input";
import {FieldResource} from "../../core/modules/openapi";
import {Observable, of, switchMap} from "rxjs";

@Component({
  selector: "app-input",
  imports: [MatFormFieldModule, MatCheckboxModule, ReactiveFormsModule, CommonModule, MatInputModule, FormsModule],
  template: `
    <div class="app-input" *ngIf="visible | async; let isVisible">
      <mat-checkbox *ngIf="field.conditionallyEnabled" color="primary" [checked]="field.checked"
                    (change)="changeStatus($event)">&nbsp;&nbsp;
      </mat-checkbox>
      <mat-form-field [formGroup]="group"
                      [class]="field.conditionallyEnabled?'with-checkbox-field':'full-width-field'">
        <mat-label>{{ field.displayName }}</mat-label>
        <input matInput [formControlName]="field.name" [placeholder]="field.displayName || ''"
               [type]="field.inputType || ''" [readonly]="!field.enabled">
        <mat-hint ng-if="field.hint">{{ field.hint }}</mat-hint>
        @for (validation of field.validations; track validation) {
          <mat-error
            *ngIf="group.controls[field.name].hasError(validation.name.toLowerCase())">{{ validation.message }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  `,
  standalone: true,
  styleUrls: ['./input.component.sass']
})
export class InputComponent implements OnInit, AfterViewInit {
  @Input() field: FieldResource;
  group: FormGroup;
  defaultValue: string;
  subject: Observable<string>;
  visible: Observable<boolean>;

  constructor() {}

  ngAfterViewInit(): void {
    this.defaultValue = this.field?.value?.toString()||'';
  }

  ngOnInit() {
    this.visible = this.subject.pipe(switchMap(x => of(this.isVisible(x))));
  }

  changeStatus(event: { checked: any; }){
    if(event.checked) {
      this.group.controls[this.field.name]?.enable();
      this.field.enabled = true;
      this.group.controls[this.field.name]?.setValue(this.defaultValue);
      this.field.value = this.defaultValue;
    } else {
      this.group.controls[this.field.name]?.disable();
      this.field.enabled = false;
      this.group.controls[this.field.name]?.setValue("");
      this.field.value = "";
    }
  }

  isVisible(value:string)
  {
    if(this.field.visibilityGroup && this.field.visibilityGroup === value) {
      this.group.controls[this.field.name]?.enable();
      return true;
    } else if(!this.field.visibilityGroup) {
      this.group.controls[this.field.name]?.enable();
      return true;
    } else {
      this.group.controls[this.field.name]?.disable();
      return false;
    }
  }
}
